module.exports = __webpack_public_path__ + "static/media/mastercard.7c8813a8.svg";